export default "/_next/static/videos/band-dark-square.mp4";